import React from "react";
import { Link } from "react-router-dom";

const Banner = () => {
 
  // const [first, setfirst] = useState(true);
  // const [sec, setsec] = useState(false);
  // const [three, setthree] = useState(false);
  // const firstSlide = () => {
  //   setsec(false);
  //   setthree(false);
  //   setfirst(true);
  // };
  // const Secondslide = () => {
  //   setsec(true);
  //   setthree(false);
  //   setfirst(false);
  // };
  // const thredslide = () => {
  //   setsec(false);
  //   setthree(true);
  //   setfirst(false);
  // };
  return (
    <section className="hero" style={{backgroundImage: 'url("https://similux-vinovatheme.myshopify.com/cdn/shop/files/s-4-2_0368bc41-bc53-4a59-a91c-02961c1d0ff8_1512x.jpg?v=1674012725")',backgroundRepeat:"no-repeat",height:'100vh', backgroundSize:"cover"}}>
      <div className="container d-xl-flex align-items-start">
        <div className="hero_about col-xl-6">
          <div className="hero_header">
            <h1 className="hero_header-title text-light">
            Trending now
            </h1>
            <h2 className="hero_header-text text-light">
            women jacket
            </h2>
            <Link className="hero_header-btn btn" to="/shop">
              Our Products
            </Link>
          </div>
          <div className="hero_contacts">
            <p className="hero_contacts-text">
              Our support team is available 24/7 to resolve any product issues
            </p>
            <span className="hero_contacts-data d-flex flex-column flex-sm-row align-items-center">
              <span className="icon d-flex align-items-center justify-content-center">
                <i className="icon-call" />
              </span>
              <span className="d-flex flex-column">
                <span>Phone number</span>{" "}
                <a className="link" href="tel:+1234567890">
                  +1-202-555-0133
                </a>
              </span>
            </span>
          </div>
        </div>
        <div className="hero_promo col-xl-6">
          <div className="hero_promo-underlay" />
          <div className="hero_promo-underlay--highlight" />
          {/*  */}
        </div>
      </div>
    </section>
  );
};

export default Banner;
